import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-796002eb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "phone-action animate__animated animate__flipInX animate__fast"
};
const _hoisted_2 = {
  class: "phone-item w100"
};
const _hoisted_3 = {
  class: "phone-btn"
};
import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElForm, ElMessage } from 'element-plus';
import { padLeftZero } from '@/utils/math';
import { getPhoneCodeApi } from '@/service/modules/login';
export default /*#__PURE__*/_defineComponent({
  __name: 'phone-action',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const phoneReg = /^1[3456789]\d{9}$/ig;
    const phoneFormRef = ref();
    const tipText = ref('获取手机验证码');
    const codeBtnDisabled = ref(false);
    let codeTimer = ref();
    const phoneForm = reactive({
      mobile: '15579816582',
      captcha: ''
    });
    const rules = {
      mobile: [{
        required: true,
        message: '请输入手机号码',
        trigger: 'blur'
      }, {
        pattern: phoneReg,
        message: '请输入正确的手机格式',
        trigger: 'blur'
      }],
      captcha: [{
        required: true,
        message: '请输入手机验证码',
        trigger: 'blur'
      }]
    };
    const loginStatus = ref(false);
    function handlePhoneCode() {
      if (codeBtnDisabled.value) return;
      clearInterval(codeTimer.value);
      if (!phoneReg.test(phoneForm.mobile)) {
        ElMessage.error('请输入正确的手机号码格式');
        return;
      }
      getPhoneCodeFn();
      let second = 60;
      codeBtnDisabled.value = true;
      codeTimer.value = setInterval(() => {
        if (second <= 0) {
          second = 60;
          clearInterval(codeTimer.value);
          codeBtnDisabled.value = false;
          tipText.value = '获取手机验证码';
          return;
        }
        --second;
        tipText.value = `${padLeftZero(second)}s后重新获取`;
      }, 1000);
    }
    async function getPhoneCodeFn() {
      try {
        let res = await getPhoneCodeApi(phoneForm);
      } catch {}
    }
    function handleLogin() {
      phoneFormRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    function submit() {
      loginStatus.value = true;
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        ref_key: "phoneFormRef",
        ref: phoneFormRef,
        model: phoneForm,
        rules: rules,
        "label-width": "70px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "手机号",
          prop: "mobile"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入手机号",
            modelValue: phoneForm.mobile,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => phoneForm.mobile = $event),
            size: "large"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "验证码",
          prop: "captcha"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
            placeholder: "请输入手机验证码",
            modelValue: phoneForm.captcha,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => phoneForm.captcha = $event),
            size: "large"
          }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
            size: "large",
            disabled: codeBtnDisabled.value,
            onClick: handlePhoneCode
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(tipText.value), 1)]),
            _: 1
          }, 8, ["disabled"])])])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-top": "40px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            loading: loginStatus.value,
            size: "large",
            type: "primary",
            class: "w100",
            onClick: handleLogin
          }, {
            default: _withCtx(() => [_createTextVNode("登 录")]),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});